import { Permissions } from "@/modules/roles/domain/contracts/permissions";
import type { PermissionId } from "@/modules/roles/domain/contracts/permissions";
import type { LucideIcon } from "lucide-react";
import {
  CalendarClock,
  ClipboardCheck,
  FileText,
  BarChart3,
  FolderKanban,
  ListTodo,
  ScrollText,
  Settings,
  Target,
  Users,
} from "lucide-react";

export type DashboardShortcutItem = {
  title: string;
  url: string;
  icon: LucideIcon;
  /** ມີຢ່າງໜຶ່ງ (OR) ເພື່ອສະແດງ shortcut ນີ້ */
  permissionsAny: PermissionId[];
};

export const dashboardShortcuts: DashboardShortcutItem[] = [
  {
    title: "ພາບລວມ KPI",
    url: "/app/management/okr-kpi",
    icon: Target,
    permissionsAny: [Permissions.mgmt_okr_kpi.read, Permissions.kpi.read],
  },
  {
    title: "ຄຳນວນ KPI ຕາມຊ່ວງເວລາ",
    url: "/app/management/okr-kpi/calculation",
    icon: Target,
    permissionsAny: [Permissions.mgmt_okr_kpi.read, Permissions.kpi.read],
  },
  {
    title: "ປະຕິທິນວຽກ",
    url: "/app/management/calendar",
    icon: CalendarClock,
    permissionsAny: [Permissions.mgmt_calendar.read, Permissions.mgmt_calendar.team],
  },
  {
    title: "ກຳນົດວັນພັກ",
    url: "/app/management/calendar/settings",
    icon: Settings,
    permissionsAny: [Permissions.mgmt_calendar.settings],
  },
  {
    title: "ລາຍການໂຄງການ",
    url: "/app/management/projects",
    icon: FolderKanban,
    permissionsAny: [Permissions.mgmt_project.read],
  },
  {
    title: "ສະຫຼຸບໂຄງການ",
    url: "/app/management/projects/summary",
    icon: BarChart3,
    permissionsAny: [
      Permissions.mgmt_project.read,
      Permissions.mgmt_project.list,
    ],
  },
  {
    title: "ສະຫຼຸບ QC",
    url: "/app/qc/result",
    icon: ClipboardCheck,
    permissionsAny: [Permissions.qc_result.read],
  },
  {
    title: "ບັນທຶກການປະຊຸມ",
    url: "/app/management/meetings",
    icon: Users,
    permissionsAny: [Permissions.mgmt_meeting.read, Permissions.mgmt_meeting.list],
  },
  {
    title: "ຕິດຕາມປະເດັນທີ່ລົມກັນ",
    url: "/app/management/meetings/actions",
    icon: ListTodo,
    permissionsAny: [Permissions.mgmt_meeting.read],
  },
  {
    title: "ລາຍງານປະຈຳເດືອນ",
    url: "/app/management/monthly-reports",
    icon: FileText,
    permissionsAny: [Permissions.mgmt_monthly_report.read],
  },
  {
    title: "ລາຍການ KPI",
    url: "/app/kpis",
    icon: Target,
    permissionsAny: [Permissions.kpi.read],
  },
  {
    title: "ລາຍການເອກະສານ",
    url: "/app/documents",
    icon: FileText,
    permissionsAny: [Permissions.quotation_invoice.read],
  },
  {
    title: "ສັນຍາໃກ້ຫມົດອາຍຸ",
    url: "/app/contracts/expiring",
    icon: ScrollText,
    permissionsAny: [Permissions.contracts.read],
  },
  {
    title: "ສະຫຼຸບ Checklist",
    url: "/app/checklists/result",
    icon: ClipboardCheck,
    permissionsAny: [Permissions.checklists.read],
  },
];
